import { Card, CardBody, CardHeader, CardTitle } from '../components/ui/Card.js';

interface PlaceholderProps {
  title: string;
  storyId: string;
  description: string;
}

/**
 * Vista placeholder usada por todas las rutas V1 que serán implementadas
 * en stories siguientes (PWA-022+ a PWA-029).
 */
export function Placeholder({ title, storyId, description }: PlaceholderProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardBody>
        <p>{description}</p>
        <p className="mt-4 text-sm text-gray-500">
          Pantalla pendiente de implementación. Tracking:{' '}
          <span className="font-mono text-distrito-700">{storyId}</span>.
        </p>
      </CardBody>
    </Card>
  );
}
